import styled from "styled-components";
import { Space, Divider as AntDivider } from "antd";
import { IMG_WHEEL_BG, SpinContainerBg, RefreshOutlined } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow-y: auto;
	background-color: #0c0b09 !important;
`;
export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Title = styled.div`
	text-align: center;
	color: #ffffff;
	font-size: 16px;
	font-weight: 500;
	line-height: 18px;
	margin-bottom: 9px;
	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const Number = styled.div`
	margin: 7px 0;
	border-right: 2px solid #424242;
	padding: 12px;
	width: 20px;
	color: #f9f9f9;
	font-size: 12px;
	font-weight: 500;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 10px;
		line-height: 10px;
	}
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;

export const TopBgImage = styled.img.attrs({
	alt: "bg-img",
	src: SpinContainerBg,
})`
	position: fixed;
	top: 69px;
	width: 100%;
	max-width: 480px;
	height: 320px;
	z-index: 500;

	@media screen and (max-width: 350px) {
		height: 300px;
	}
	@media screen and (max-height: 650px) {
		height: 250px;
	}
	/* @media screen and (min-width: 400px) {
		height: 320px;
	} */
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 301px;
	height: 301px;
	border-radius: 50%;
	cursor: pointer;
	z-index: 200;
	top: 14px;
	margin-left: 5px;

	@media screen and (max-width: 350px) {
		width: 260px;
		height: 260px;
		margin-left: 4px;
		top: 32px;
	}
	@media screen and (max-height: 650px) {
		width: 238px;
		height: 238px;
		margin-left: -1px;
		top: 5px;
	}
`;

export const WheelContainer = styled.div`
	position: fixed;
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 220px;
		height: 220px;
		transform: rotate(-48deg);
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		> div {
			width: 190px;
			height: 190px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 170px;
			height: 170px;
		}
		height: 220px;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	margin-top: 350px;

	.ant-btn {
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: #f9f9f9;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	max-height: 332px;
	padding: 0 8px;
	position: relative;
	overflow: auto;
	@media (max-height: 1300px) {
		height: 255px;
	}
	@media (max-height: 800px) {
		height: 257px;
	}
	@media (max-height: 734px) {
		height: 193px;
	}
	@media (max-height: 683px) {
		height: 173px;
	}
	@media (max-height: 650px) {
		height: 192px;
	}
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 0;
	border-bottom: 2px solid #424242;
	@media screen and (max-height: 670px) {
		height: 47px;
	}
`;

export const LeftSection = styled.div`
	display: flex;
`;

export const PhNameWrapper = styled.div`
	padding: 12px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 3;
`;

export const NameWrapper = styled.div`
	color: #f9f9f9;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const PhoneWrapper = styled.div`
	color: #a0a0a0;
	font-size: 12px;
	font-weight: 300;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const AmountWrapper = styled.div`
	padding: 12px;
	color: #f9f9f9;
	font-size: 12px;
	font-weight: 500;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 1000;
	margin-top: 318px;
	position: relative;
	@media screen and (max-height: 650px) {
		margin-top: 250px;
	}
`;

export const TableContainer = styled.div`
	margin-top: 8px;
	background: #0e1017;
	height: 315px;
	/* height: ${(props) => props.height}; */
	width: 358px;
	z-index: 99;
	border: 2px solid #424242;
	border-radius: 12px;
	position: relative;
	@media (max-width: 370px) {
		width: 330px;
	}
	@media (max-width: 330px) {
		width: 300px;
	}
	@media screen and (max-height: 734px) {
		height: 252px;
	}
	@media screen and (max-height: 683px) {
		height: 232px;
	}
`;

export const ButtonWrapper = styled.div`
	background: linear-gradient(#9a711e, #ffb829) !important;
	height: 49.25px;
	border-radius: 0px 0px 12px 12px;
	display: flex;
	justify-content: space-between;
	padding: 5px 0;
	margin-top: 400px;
	position: absolute;
	bottom: 0;
	width: 100%;
	@media screen and (max-height: 650px) {
		height: 30px;
	}
`;

export const ButtonDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	cursor: pointer;
	font-size: 16px;
	font-weight: 600;
	color: #000000;
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const DividerWrapper = styled.div`
	width: 32.04px;
	margin: 0 auto;
	transform: rotate(90deg);
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Divider = styled(AntDivider)`
	/* margin: 16px 0 24px; */
	border-color: #d28a28;
`;

export const CenterIcon = styled.img.attrs((props) => ({
	id: props.id,
	src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
